import s from "./alert.module.css";
import {alertBackground} from "../../../../assets";
import {useAppContext} from "../../../../contexts";

const Alert = (props) => {
    // Destructured props
    const {
        showAlert,
        hasSynchronizedThirdStep
    } = props;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    if (!hasSynchronizedThirdStep) {
        return null;
    }

    return (
        <div
            id={"alert"}
            className={`${s.root} ${showAlert ? s.fadeIn : s.hideContent}`}
        >
            <div className={
                `flex flex-col-reverse items-center justify-start gap-y-14 gap-x-10 md:gap-x-24 transition-all duration-50 md:flex-row`
            }>
                <img
                    src={alertBackground}
                    className={s.image}
                    alt="Background image"
                />
                <div className={"w-full flex flex-col items-start justify-between gap-y-6"}>
                    <h1 className={`${s.heading} ${highContrast ? "!text-[#fecc31]" : ""}`}>
                        Falta apenas 2 perguntas!
                    </h1>
                    <p className={`${s.paragraph} ${highContrast ? "!text-white" : ""}`}>
                        Você está indo muito bem! Vamos continuar aprimorando cada vez mais nossos serviços para você!
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Alert;
